export const isCurrentPage = (path?: string | null) => {
  if (typeof window !== "undefined" && path) {
    if (path === "/") {
      return window.location.pathname === path;
    }
    return window.location.pathname.includes(path);
  }
  return false;
};
